'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  'arrow-left': function arrowLeft(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 3 6'
    }, _react2.default.createElement('path', {
      fill: color,
      transform: 'translate(3) rotate(90)',
      fillRule: 'evenodd',
      d: 'M6 0 3 3 0 0Z'
    }));
  },
  'arrow-right': function arrowRight(size, color) {
    return _react2.default.createElement('svg', {
      width: size,
      height: size,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 3 6'
    }, _react2.default.createElement('path', {
      transform: 'translate(0 6) rotate(-90)',
      id: 'svg_1',
      d: 'M6 0 3 3 0 0Z',
      fillRule: 'evenodd',
      fill: color
    }));
  },
  folder: function folder(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 14',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M13.824 14H2.166C.972 14 0 13.014 0 11.801V2.2C0 .987.972 0 2.166 0H6.82l1.753 3.001H14c1.215 0 2 .785 2 1.999l-.011 6.802c0 1.212-.971 2.198-2.165 2.198zM2.166 1.999c-.09 0-.166.092-.166.201v9.601c0 .108.076.2.166.2h11.658c.09 0 .165-.092.165-.2L14 5H7.426L5.672 1.999H2.166z'
    }));
  },
  'arrow-down-small': function arrowDownSmall(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 8 6',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M3.999 6.001L0 1.291 1.528-.001 3.999 2.91 6.471-.001l1.527 1.292-3.999 4.71z'
    }));
  },
  chevron: function chevron(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 8 6',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M3.998 6.001L0 1.29 1.528-.001l2.47 2.911L6.471-.001 7.998 1.29l-4 4.711z'
    }));
  },
  trash: function trash(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M15 6v10H1V6H0V0h16v6h-1zM3 14h10V6H3v8zM14 2H2v2h12V2zM9 7h2v6H9V7zM5 7h2v6H5V7z'
    }));
  },
  arrow: function arrow(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 10 16',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M1.36 15.997l-1.359-1.47 7.051-6.528L.001 1.47 1.36 0l8.639 7.999-8.639 7.998z'
    }));
  },
  'check-upload': function checkUpload(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M12 24C5.372 24 0 18.627 0 12 0 5.372 5.372 0 12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12zm0-22C6.477 2 2 6.477 2 12c0 5.522 4.477 9.999 10 9.999 5.522 0 9.999-4.477 9.999-9.999 0-5.523-4.477-10-9.999-10zm-1.758 14.99L6.01 12.833l1.411-1.385 2.821 2.771 6.347-6.234L18 9.37l-7.758 7.62z'
    }));
  },
  check: function check(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 12',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M5.5 11.999L-.001 6.461l1.415-1.413L5.499 9.16 14.585.001l1.416 1.412L5.5 11.999z'
    }));
  },
  close: function close(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    }, _react2.default.createElement('g', {
      id: 'close',
      transform: 'translate(-435 -467)'
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M10.4,8.8l7.3-7.1a.967.967,0,0,0,0-1.4.967.967,0,0,0-1.4,0L9,7.4,1.7.3A.967.967,0,0,0,.3.3a.967.967,0,0,0,0,1.4L7.6,8.8.3,15.9a.967.967,0,0,0,0,1.4,1.08,1.08,0,0,0,.7.3.908.908,0,0,0,.7-.3L9,10.2l7.3,7.1a.967.967,0,0,0,1.4,0,.967.967,0,0,0,0-1.4Z',
      transform: 'translate(442 474)'
    })));
  },
  file: function file(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 12 14'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M11.972 12.999c0 .553-.449 1.001-1.001 1.001h-9.97A1.001 1.001 0 0 1 0 12.999V1.005c0-.552.448-1 1-1.001L6.999 0H7l5 5s-.028 4.886-.028 7.999zM5.999 6V2h-.005v.001l-3.992.003v9.995h7.969c.005-2.541.026-5.978.026-5.999H5.999z'
    }));
  },
  'file-download': function fileDownload(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 113 119'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M112.515 83.748a2.995 2.995 0 0 0-2.725-1.757H98.813l.024-28.01a3 3 0 0 0-2.995-3.002H85.835V30.997c0-.021-.006-.04-.006-.06a3.088 3.088 0 0 0-.053-.534c-.005-.023-.015-.045-.02-.069a3.167 3.167 0 0 0-.134-.435 3.212 3.212 0 0 0-.071-.159 2.854 2.854 0 0 0-.176-.326c-.028-.046-.055-.092-.086-.137a2.988 2.988 0 0 0-.323-.392l-.01-.011L57.012.88l-.011-.009a2.948 2.948 0 0 0-.393-.325c-.043-.03-.088-.056-.133-.084a2.93 2.93 0 0 0-.33-.179c-.051-.024-.102-.048-.155-.069a3.04 3.04 0 0 0-.444-.138c-.02-.004-.039-.012-.059-.016a3.031 3.031 0 0 0-.539-.055c-.019 0-.036-.005-.055-.005H2.992A2.996 2.996 0 0 0-.002 2.999v95.99c0 1.657 1.34 3 2.994 3h63.63v-.084l13.96 16.065a2.993 2.993 0 0 0 4.517 0l26.949-31.01a3.002 3.002 0 0 0 .467-3.212zM75.612 27.997H57.887V10.241l17.725 17.756zM5.986 95.99V5.999h45.913v24.998a2.997 2.997 0 0 0 2.994 2.999h24.953v16.983H69.839a3 3 0 0 0-2.995 3.002l.025 28.01H55.892a3.002 3.002 0 0 0-2.259 4.969l7.847 9.03H5.986zm76.855 15.442L62.469 87.991h7.396a3.003 3.003 0 0 0 2.995-3.003l-.025-28.01h20.011l-.024 28.01a2.998 2.998 0 0 0 2.994 3.003h7.396l-20.371 23.441z'
    }));
  },
  pencil: function pencil(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M15.698 4.591L11.4.294c-.374-.375-1.039-.375-1.414 0L1.325 8.953a.997.997 0 0 0-.274.515L.009 14.806a1 1 0 0 0 1.173 1.17l5.34-1.042a.993.993 0 0 0 .515-.274l8.661-8.659a.996.996 0 0 0 0-1.41zM2.921 10.325l2.747 2.743-3.412.665.665-3.408zm4.228 1.399L4.262 8.842l6.431-6.43 2.885 2.884-6.429 6.428z'
    }));
  },
  plus: function plus(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 8 8',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M8 5H5v3H3V5H-.001V3H3V0h2v3h3v2z'
    }));
  },
  'power-off': function powerOff(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 22 24'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M11 23.997c-6.065 0-11-4.998-11-11.141C0 8.66 2.297 4.861 5.994 2.942l.92 1.779c-3.03 1.574-4.913 4.69-4.913 8.135 0 5.038 4.037 9.138 8.999 9.138 4.962 0 9-4.1 9-9.138 0-3.445-1.884-6.561-4.915-8.135l.92-1.779C19.703 4.861 22 8.66 22 12.856c0 6.143-4.934 11.141-11 11.141zM10 0h2v12h-2V0z'
    }));
  },
  'remove-smarttag': function removeSmarttag(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 8 8',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M7.993 6.662L6.662 7.993 4 5.331 1.338 7.993.007 6.662 2.669 4 .007 1.338 1.338.007 4 2.669 6.662.007l1.331 1.331L5.331 4l2.662 2.662z'
    }));
  },
  search: function search(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M24.014 22.554l-1.46 1.46-6.253-6.253A9.956 9.956 0 0 1 10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10a9.956 9.956 0 0 1-2.239 6.301l6.253 6.253zM10 2a8 8 0 0 0-8 8 8 8 0 1 0 16 0 8 8 0 0 0-8-8z'
    }));
  },
  'search-document': function searchDocument(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 111 102',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M110.979 30.941a3.07 3.07 0 0 0-.054-.534c-.005-.024-.014-.046-.02-.07a2.917 2.917 0 0 0-.383-.919c-.029-.047-.056-.093-.087-.137a2.948 2.948 0 0 0-.325-.393l-.01-.011L81.983.881l-.012-.01a3.021 3.021 0 0 0-.394-.325c-.044-.03-.09-.056-.135-.084a3.137 3.137 0 0 0-.332-.18c-.052-.023-.102-.047-.155-.067a2.908 2.908 0 0 0-.454-.141L80.449.06a3.12 3.12 0 0 0-.546-.055c-.018 0-.034-.005-.053-.005H27.627a3.006 3.006 0 0 0-3.013 3v14.766C10.722 19.698-.007 31.599-.007 45.955c0 14.355 10.729 26.256 24.621 28.188V99c0 1.657 1.349 3 3.013 3h80.345a3.007 3.007 0 0 0 3.013-3V31c0-.021-.006-.039-.006-.059zM100.698 28H82.864V10.242L100.698 28zM6.019 45.955c0-12.39 10.124-22.47 22.567-22.47s22.566 10.08 22.566 22.47c0 12.389-10.123 22.468-22.566 22.468S6.019 58.344 6.019 45.955zM104.959 96H30.64V74.342c6-.427 11.495-2.701 15.908-6.259l17.628 17.551c.588.587 1.36.88 2.13.88.771 0 1.543-.293 2.131-.88a2.991 2.991 0 0 0 0-4.242L50.809 63.84c3.979-4.892 6.369-11.115 6.369-17.885 0-15.01-11.729-27.335-26.538-28.388V6h46.197v25c0 1.656 1.35 3 3.013 3h25.109v62z'
    }));
  },
  'arrow-top': function arrowTop(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 6 3'
    }, _react2.default.createElement('path', {
      fill: color,
      transform: 'translate(6 3) rotate(180)',
      fillRule: 'evenodd',
      d: 'M6 0 3 3 0 0Z'
    }));
  },
  'arrow-down': function arrowDown(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 6 3'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M6 0 3 3 0 0Z'
    }));
  },
  home: function home(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 16 16'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M14.883 7.013L7.999 2.407 1.115 7.013.001 5.352 7.999 0l7.999 5.352-1.115 1.661zM3.993 14h8.012V8.001h2.003V16H1.991V8.001h2.002V14z'
    }));
  },
  'expand-down': function expandDown(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 8 4'
    }, _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M8 0L4 4-.001 0H8z'
    }));
  },
  ownership: function ownership(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5a2.006,2.006,0,0,0-2-2H5A2,2,0,0,0,3,5ZM15,9a3,3,0,1,1-3-3A3,3,0,0,1,15,9ZM6,17c0-2,4-3.1,6-3.1S18,15,18,17v1H6Z'
    }), _react2.default.createElement('path', {
      fill: 'none',
      d: 'M0,0H24V24H0Z'
    }));
  },
  pin: function pin(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 21.581 21.9',
      width: size,
      height: size
    }, _react2.default.createElement('g', {
      transform: 'translate(-0.019)'
    }, _react2.default.createElement('path', {
      fill: 'none',
      d: 'M9.6,7.6a1.086,1.086,0,0,1-.9.4A6.264,6.264,0,0,0,4.1,9.3l3.2,3.2,2.1,2.1h0l.1.1,3.1,3.1a6.2,6.2,0,0,0,1.2-4.9.951.951,0,0,1,.4-1l4.9-3.7L13.4,2.5Z'
    }), _react2.default.createElement('path', {
      fill: 'none',
      d: 'M5.4,16.4l1.8-1.2-.5-.5Z'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M21.6,8.4a1.136,1.136,0,0,0-.3-.8L14,.3a.908.908,0,0,0-.7-.3.842.842,0,0,0-.7.4L8.3,6A8.438,8.438,0,0,0,2,8.5a1.08,1.08,0,0,0-.3.7.908.908,0,0,0,.3.7l3.3,3.3L.2,20.3a1.059,1.059,0,0,0,.1,1.3.908.908,0,0,0,.7.3,1.421,1.421,0,0,0,.6-.2l7.1-5.1L12,19.9a1.08,1.08,0,0,0,.7.3.908.908,0,0,0,.7-.3,8.018,8.018,0,0,0,2.5-6.8l5.4-4A1.08,1.08,0,0,0,21.6,8.4Zm-16.2,8,1.3-1.8.5.5Zm8.8-4.5a.951.951,0,0,0-.4,1,6.2,6.2,0,0,1-1.2,4.9L9.5,14.7l-.1-.1h0L7.3,12.5,4.1,9.3A6.264,6.264,0,0,1,8.7,8a1.086,1.086,0,0,0,.9-.4l3.9-5.1,5.7,5.7Z'
    })));
  },
  info: function info(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 15.999 16.001',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fillRule: 'evenodd',
      fill: color,
      d: 'M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9.666,12.4c-.413.161-.74.285-.987.37a2.632,2.632,0,0,1-.854.127,1.706,1.706,0,0,1-1.163-.365,1.168,1.168,0,0,1-.414-.926,3.1,3.1,0,0,1,.032-.445,4.6,4.6,0,0,1,.1-.515l.515-1.821c.045-.174.085-.338.117-.494A2.063,2.063,0,0,0,7.055,7.9a.658.658,0,0,0-.143-.484.81.81,0,0,0-.55-.138,1.538,1.538,0,0,0-.41.061c-.121.037-.241.076-.36.119L5.73,6.9c.336-.138.658-.254.969-.353A2.9,2.9,0,0,1,7.571,6.4a1.674,1.674,0,0,1,1.146.359,1.193,1.193,0,0,1,.4.932c0,.079-.007.219-.026.418a2.843,2.843,0,0,1-.1.549l-.513,1.816a4.944,4.944,0,0,0-.114.5,2.724,2.724,0,0,0-.047.424.611.611,0,0,0,.161.494.906.906,0,0,0,.561.13,1.679,1.679,0,0,0,.423-.064,2.525,2.525,0,0,0,.341-.116ZM9.573,5.031a1.216,1.216,0,0,1-.862.333,1.235,1.235,0,0,1-.867-.333,1.06,1.06,0,0,1-.361-.807,1.082,1.082,0,0,1,.361-.812,1.22,1.22,0,0,1,.867-.336,1.2,1.2,0,0,1,.862.336,1.074,1.074,0,0,1,.36.812A1.057,1.057,0,0,1,9.573,5.031Z',
      transform: 'translate(0 0.001)'
    }));
  },
  done: function done(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 11.4 9.1'
    }, _react2.default.createElement('polygon', {
      fill: color,
      points: '4,9.1 0,5 1.4,3.6 4,6.3 10,0 11.4,1.4 '
    }));
  },
  'add-machine': function addMachine(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, _react2.default.createElement('path', {
      d: 'M21,0H10.6a.945.945,0,0,0-1,1,.945.945,0,0,0,1,1H21a.945.945,0,0,1,1,1v7H4a.945.945,0,0,0-1,1v8a2.946,2.946,0,0,0,3,3H7v1a.945.945,0,0,0,1,1H19a.945.945,0,0,0,1-1V22h1a2.946,2.946,0,0,0,3-3V3A2.946,2.946,0,0,0,21,0ZM6,20a.945.945,0,0,1-1-1V12H7v8Zm12,2H9V12h9Zm3-2H20V12h2v7A.945.945,0,0,1,21,20Z',
      fill: color,
      'data-name': 'Path 259',
      id: 'Path_259'
    }), _react2.default.createElement('circle', {
      transform: 'translate(16 4)',
      r: '1.5',
      cy: '1.5',
      cx: '1.5',
      fill: color,
      'data-name': 'Ellipse 29',
      id: 'Ellipse_29'
    }), _react2.default.createElement('path', {
      d: 'M3,8H5V5H8V3H5V0H3V3H0V5H3Z',
      fill: color,
      'data-name': 'Path 260',
      id: 'Path_260'
    }));
  },
  'customer-ownership': function customerOwnership(size, color) {
    return _react2.default.createElement('svg', {
      id: 'outline-person_outline-24px',
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, _react2.default.createElement('path', {
      d: 'M12,5.9A2.1,2.1,0,1,1,9.9,8,2.1,2.1,0,0,1,12,5.9m0,9c2.97,0,6.1,1.46,6.1,2.1v1.1H5.9V17c0-.64,3.13-2.1,6.1-2.1M12,4a4,4,0,1,0,4,4A4,4,0,0,0,12,4Zm0,9c-2.67,0-8,1.34-8,4v3H20V17C20,14.34,14.67,13,12,13Z',
      'data-name': 'Path 248',
      id: 'Path_248',
      fill: color
    }));
  },
  'add-contact': function addContact(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M 21,3 H 11 V 5 H 21 V 21 H 5 V 11 H 3 v 10 a 2.006,2.006 0 0 0 2,2 h 16 a 2.006,2.006 0 0 0 2,-2 V 5 A 2.006,2.006 0 0 0 21,3 Z',
      'data-name': 'Path 207',
      id: 'Path_207'
    }), _react2.default.createElement('path', {
      id: 'Path_208',
      'data-name': 'Path 208',
      fill: color,
      d: 'M 5,5 H 8 V 3 H 5 V 0 H 3 V 3 H 0 v 2 h 3 v 3 h 2 z'
    }), _react2.default.createElement('path', {
      id: 'Path_210',
      'data-name': 'Path 210',
      fill: color,
      d: 'm 13,13.9 c -2,0 -6,1.1 -6,3.6 V 19 H 19 V 17.5 C 19,15 15,13.9 13,13.9 Z m 4.5,3.6 h -9 c 0,-1.1 2.8,-2.1 4.5,-2.1 1.7,0 4.5,0.9 4.5,2.1 z'
    }), _react2.default.createElement('path', {
      id: 'Path_211',
      'data-name': 'Path 211',
      d: 'm 13,13 a 2.946,2.946 0 0 0 3,-3 2.946,2.946 0 0 0 -3,-3 2.946,2.946 0 0 0 -3,3 2.946,2.946 0 0 0 3,3 z M 13,8.5 A 1.538,1.538 0 0 1 14.5,10 1.538,1.538 0 0 1 13,11.5 1.538,1.538 0 0 1 11.5,10 1.538,1.538 0 0 1 13,8.5 Z',
      fill: color
    }));
  },
  'add-activity': function addActivity(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      id: 'svg12',
      version: '1.1',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('rect', {
      id: 'Rectangle_594',
      'data-name': 'Rectangle 594',
      fill: color,
      width: '9',
      height: '1',
      transform: 'translate(7 7.5)'
    }), _react2.default.createElement('rect', {
      id: 'Rectangle_595',
      'data-name': 'Rectangle 595',
      fill: color,
      width: '4',
      height: '1',
      transform: 'translate(7 10.5)'
    }), _react2.default.createElement('path', {
      id: 'Path_251',
      'data-name': 'Path 251',
      fill: color,
      d: 'M21,6a2.384,2.384,0,0,1,1.1.6l.9.9V5a2.006,2.006,0,0,0-2-2H11V5H21Z'
    }), _react2.default.createElement('path', {
      id: 'Path_252',
      'data-name': 'Path 252',
      fill: color,
      d: 'M21,21H15.2l-2,2H21a2.006,2.006,0,0,0,2-2V13.2l-2,2Z'
    }), _react2.default.createElement('path', {
      id: 'Path_253',
      'data-name': 'Path 253',
      fill: color,
      d: 'M5,11H3V21a2.006,2.006,0,0,0,2,2H6V21H5Z'
    }), _react2.default.createElement('path', {
      id: 'Path_254',
      'data-name': 'Path 254',
      fill: color,
      d: 'M17,10.3,7,20.3V24h3.8l10-10ZM9.9,22H9v-.9l8-8,.9.9Z'
    }), _react2.default.createElement('path', {
      id: 'Path_255',
      'data-name': 'Path 255',
      fill: color,
      d: 'M23.7,9.6,21.4,7.3a.967.967,0,0,0-1.4,0l-2,2,3.8,3.8,2-2A1.2,1.2,0,0,0,23.7,9.6Z'
    }), _react2.default.createElement('path', {
      id: 'Path_256',
      'data-name': 'Path 256',
      fill: color,
      d: 'M3,8H5V5H8V3H5V0H3V3H0V5H3Z'
    }));
  },
  'add-opportunity': function addOpportunity(size, color) {
    return _react2.default.createElement('svg', {
      version: '1.1',
      id: 'Layer_1',
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 24 24',
      xmlSpace: 'preserve',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      id: 'icon_05',
      transform: 'translate(-9522 -2108)',
      className: 'st0',
      fill: color,
      d: 'M9538,2118l2.3,2.3l-4.9,4.9l-4-4l-7.4,7.4l1.4,1.4l6-6l4,4 l6.3-6.3l2.3,2.3v-6H9538z M9528,2114h3v-2h-3v-3h-2v3h-3v2h3v3h2V2114z'
    }));
  },
  'add-competitor': function addCompetitor(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      id: 'Path_268',
      'data-name': 'Path 268',
      d: 'M 20,1 A 3.924,3.924 0 0 0 16.5,3.1 0.9,0.9 0 0 0 16,3 H 8 A 0.9,0.9 0 0 0 7.5,3.1 3.924,3.924 0 0 0 4,1 4.012,4.012 0 0 0 0,5 C 0,7.3 2.5,8.4 3.6,8.9 4.3,9.2 6,10 6,11 A 2.088,2.088 0 0 1 5.2,12.6 1.922,1.922 0 0 1 4,13 v 2 A 4.069,4.069 0 0 0 6.4,14.2 C 6.6,14 6.8,13.9 7,13.7 A 12.243,12.243 0 0 0 8.9,18.2 3.96,3.96 0 0 0 6,22 v 1 h 12 v -1 a 3.992,3.992 0 0 0 -2.8,-3.8 12.243,12.243 0 0 0 1.9,-4.5 2.651,2.651 0 0 0 0.6,0.5 4.069,4.069 0 0 0 2.4,0.8 V 13 A 1.922,1.922 0 0 1 18.9,12.6 2.088,2.088 0 0 1 18.1,11 c 0,-1 1.7,-1.8 2.4,-2.1 C 21.5,8.4 24,7.3 24,5 A 4.012,4.012 0 0 0 20,1 Z M 4.4,7.1 C 3.7,6.8 2,6 2,5 A 2,2 0 0 1 6,5 C 6,5.4 6,6.5 6.1,8 A 14.679,14.679 0 0 0 4.4,7.1 Z M 16,5 C 16,9.2 15,18 12,18 9,18 8,9.2 8,5 Z M 15.7,21 H 8.3 A 1.936,1.936 0 0 1 10,20 h 4 a 1.936,1.936 0 0 1 1.7,1 z M 19.6,7.1 A 14.679,14.679 0 0 0 17.9,8 C 18,6.5 18,5.4 18,5 a 2,2 0 0 1 4,0 c 0,1 -1.7,1.8 -2.4,2.1 z',
      fill: color
    }));
  },
  'add-pricelist': function addPricelist(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      d: 'M 21,3 H 11 V 5 H 21 V 21 H 5 V 11 H 3 v 10 a 2.006,2.006 0 0 0 2,2 h 16 a 2.006,2.006 0 0 0 2,-2 V 5 A 2.006,2.006 0 0 0 21,3 Z',
      fill: color,
      'data-name': 'Path 207',
      id: 'Path_207'
    }), _react2.default.createElement('path', {
      id: 'Path_208',
      'data-name': 'Path 208',
      fill: color,
      d: 'M 5,5 H 8 V 3 H 5 V 0 H 3 V 3 H 0 v 2 h 3 v 3 h 2 z'
    }), _react2.default.createElement('path', {
      id: 'Path_267',
      'data-name': 'Path 267',
      fill: color,
      d: 'm 14.884,10.807 a 3.216,3.216 0 0 0 -0.73,-0.526 1.765,1.765 0 0 0 -0.8,-0.175 1.224,1.224 0 0 0 -0.772,0.211 0.824,0.824 0 0 0 -0.266,0.683 0.717,0.717 0 0 0 0.274,0.568 3.567,3.567 0 0 0 0.688,0.442 q 0.414,0.211 0.891,0.435 A 4.7,4.7 0 0 1 15.06,13 a 2.815,2.815 0 0 1 0.688,0.779 2.162,2.162 0 0 1 0.274,1.13 2.788,2.788 0 0 1 -0.548,1.73 2.685,2.685 0 0 1 -1.642,0.961 v 1.46 H 12.47 v -1.4 A 5.009,5.009 0 0 1 11.17,17.316 3.839,3.839 0 0 1 10,16.59 l 0.898,-1.39 a 4.719,4.719 0 0 0 1.018,0.611 2.532,2.532 0 0 0 0.989,0.2 1.294,1.294 0 0 0 0.863,-0.239 0.917,0.917 0 0 0 0.274,-0.73 A 0.808,0.808 0 0 0 13.768,14.424 3.608,3.608 0 0 0 13.08,13.94 Q 12.666,13.708 12.189,13.477 A 4.984,4.984 0 0 1 11.298,12.923 2.942,2.942 0 0 1 10.61,12.165 1.965,1.965 0 0 1 10.332,11.1 2.591,2.591 0 0 1 10.9,9.381 2.623,2.623 0 0 1 12.465,8.504 V 7.06 h 1.367 v 1.418 a 3.09,3.09 0 0 1 1.179,0.407 4.35,4.35 0 0 1 0.912,0.744 z'
    }));
  },
  'add-customer': function addCustomer(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'm 15,12 a 4,4 0 1 0 -4,-4 4,4 0 0 0 4,4 z m 0,-6 a 2,2 0 1 1 -2,2 2.006,2.006 0 0 1 2,-2 z m 0,8 c -2.67,0 -8,1.34 -8,4 v 2 h 16 v -2 c 0,-2.66 -5.33,-4 -8,-4 z m -6,4 c 0.22,-0.72 3.31,-2 6,-2 2.69,0 5.8,1.29 6,2 z M 6,15 V 12 H 9 V 10 H 6 V 7 H 4 v 3 H 1 v 2 h 3 v 3 z',
      'data-name': 'Path 192',
      id: 'Path_192'
    }));
  },
  'add-service': function addService(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      d: 'M21,0H10.6a.945.945,0,0,0-1,1,.945.945,0,0,0,1,1H21a.945.945,0,0,1,1,1v7H4a.945.945,0,0,0-1,1v8a2.946,2.946,0,0,0,3,3H7v1a.945.945,0,0,0,1,1H19a.945.945,0,0,0,1-1V22h1a2.946,2.946,0,0,0,3-3V3A2.946,2.946,0,0,0,21,0ZM6,20a.945.945,0,0,1-1-1V12H7v8Zm12,2H9V12h9Zm3-2H20V12h2v7A.945.945,0,0,1,21,20Z',
      fill: color,
      'data-name': 'Path 259',
      id: 'Path_259'
    }), _react2.default.createElement('circle', {
      transform: 'translate(16 4)',
      r: '1.5',
      cy: '1.5',
      cx: '1.5',
      fill: color,
      'data-name': 'Ellipse 29',
      id: 'Ellipse_29'
    }), _react2.default.createElement('path', {
      d: 'M3,8H5V5H8V3H5V0H3V3H0V5H3Z',
      fill: color,
      'data-name': 'Path 260',
      id: 'Path_260'
    }));
  },
  'customer-qualify': function customerQualify(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M 11,12 A 4,4 0 1 0 7,8 4,4 0 0 0 11,12 Z M 11,6 A 2,2 0 1 1 9,8 2.006,2.006 0 0 1 11,6 Z M 5,18 c 0.2,-0.63 2.57,-1.68 4.96,-1.94 l 2.04,-2 A 9.341,9.341 0 0 0 11,14 c -2.67,0 -8,1.34 -8,4 v 2 h 9 L 10,18 Z M 20.6,12.5 15.47,17.67 13.4,15.59 12,17 15.47,20.5 22,13.91 Z',
      'data-name': 'Path 194',
      id: 'Path_194'
    }));
  },
  edit: function edit(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      d: 'M 14.06,9.02 14.98,9.94 5.92,19 H 5 V 18.08 L 14.06,9.02 M 17.66,3 a 1,1 0 0 0 -0.7,0.29 l -1.83,1.83 3.75,3.75 1.83,-1.83 a 1,1 0 0 0 0,-1.41 L 18.37,3.29 A 0.982,0.982 0 0 0 17.66,3 Z M 14.06,6.19 3,17.25 V 21 H 6.75 L 17.81,9.94 Z',
      fill: color,
      'data-name': 'Path 190',
      id: 'Path_190'
    }));
  },
  delete: function _delete(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: size,
      height: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M 16,9 V 19 H 8 V 9 h 8 M 14.5,3 h -5 l -1,1 H 5 V 6 H 19 V 4 H 15.5 Z M 18,7 H 6 v 12 a 2.006,2.006 0 0 0 2,2 h 8 a 2.006,2.006 0 0 0 2,-2 z',
      'data-name': 'Path 188',
      id: 'Path_188'
    }));
  },
  pdf: function pdf(size) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 309.267 309.267'
    }, _react2.default.createElement('path', {
      fill: '#E2574C',
      d: 'M38.658,0h164.23l87.049,86.711v203.227c0,10.679-8.659,19.329-19.329,19.329H38.658 c-10.67,0-19.329-8.65-19.329-19.329V19.329C19.329,8.65,27.989,0,38.658,0z'
    }), _react2.default.createElement('path', {
      fill: '#B53629',
      d: 'M289.658,86.981h-67.372c-10.67,0-19.329-8.659-19.329-19.329V0.193L289.658,86.981z'
    }), _react2.default.createElement('path', {
      fill: '#FFFFFF',
      d: 'M217.434,146.544c3.238,0,4.823-2.822,4.823-5.557c0-2.832-1.653-5.567-4.823-5.567h-18.44 c-3.605,0-5.615,2.986-5.615,6.282v45.317c0,4.04,2.3,6.282,5.412,6.282c3.093,0,5.403-2.242,5.403-6.282v-12.438h11.153 c3.46,0,5.19-2.832,5.19-5.644c0-2.754-1.73-5.49-5.19-5.49h-11.153v-16.903C204.194,146.544,217.434,146.544,217.434,146.544z M155.107,135.42h-13.492c-3.663,0-6.263,2.513-6.263,6.243v45.395c0,4.629,3.74,6.079,6.417,6.079h14.159 c16.758,0,27.824-11.027,27.824-28.047C183.743,147.095,173.325,135.42,155.107,135.42z M155.755,181.946h-8.225v-35.334h7.413 c11.221,0,16.101,7.529,16.101,17.918C171.044,174.253,166.25,181.946,155.755,181.946z M106.33,135.42H92.964 c-3.779,0-5.886,2.493-5.886,6.282v45.317c0,4.04,2.416,6.282,5.663,6.282s5.663-2.242,5.663-6.282v-13.231h8.379 c10.341,0,18.875-7.326,18.875-19.107C125.659,143.152,117.425,135.42,106.33,135.42z M106.108,163.158h-7.703v-17.097h7.703 c4.755,0,7.78,3.711,7.78,8.553C113.878,159.447,110.863,163.158,106.108,163.158z'
    }));
  },
  lock: function lock(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'
    }));
  },
  logout: function logout(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z'
    }));
  },
  profile: function profile(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 28 28'
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M23.797 20.922c-0.406-2.922-1.594-5.516-4.25-5.875-1.375 1.5-3.359 2.453-5.547 2.453s-4.172-0.953-5.547-2.453c-2.656 0.359-3.844 2.953-4.25 5.875 2.172 3.063 5.75 5.078 9.797 5.078s7.625-2.016 9.797-5.078zM20 10c0-3.313-2.688-6-6-6s-6 2.688-6 6 2.688 6 6 6 6-2.688 6-6zM28 14c0 7.703-6.25 14-14 14-7.734 0-14-6.281-14-14 0-7.734 6.266-14 14-14s14 6.266 14 14z'
    }));
  },
  painting_roller: function painting_roller(size, color) {
    return _react2.default.createElement('svg', {
      id: 'format_paint-24px',
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    }, _react2.default.createElement('path', {
      id: 'Path_193',
      'data-name': 'Path 193',
      d: 'M24.588,4.8V3.4A1.441,1.441,0,0,0,23.118,2H5.471A1.441,1.441,0,0,0,4,3.4V9a1.441,1.441,0,0,0,1.471,1.4H23.118A1.441,1.441,0,0,0,24.588,9V7.6h1.471v5.6H11.353V28.6A1.441,1.441,0,0,0,12.824,30h2.941a1.441,1.441,0,0,0,1.471-1.4V16H29V4.8Z',
      transform: 'translate(0 0)',
      fill: color
    }), _react2.default.createElement('path', {
      id: 'Path_194',
      'data-name': 'Path 194',
      d: 'M0,0H32V32H0Z',
      fill: 'none'
    }));
  },
  color_lens: function color_lens(size, color) {
    return _react2.default.createElement('svg', {
      id: 'color_lens-24px',
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    }, _react2.default.createElement('path', {
      id: 'Path_195',
      'data-name': 'Path 195',
      d: 'M16,3a13,13,0,1,0,0,26,2.168,2.168,0,0,0,1.6-3.626,2.159,2.159,0,0,1,1.618-3.6h2.557A7.225,7.225,0,0,0,29,14.556C29,8.171,23.179,3,16,3ZM8.056,16a2.167,2.167,0,1,1,2.167-2.167A2.164,2.164,0,0,1,8.056,16Zm4.333-5.778a2.167,2.167,0,1,1,2.167-2.167A2.164,2.164,0,0,1,12.389,10.222Zm7.222,0a2.167,2.167,0,1,1,2.167-2.167A2.164,2.164,0,0,1,19.611,10.222ZM23.944,16a2.167,2.167,0,1,1,2.167-2.167A2.164,2.164,0,0,1,23.944,16Z',
      transform: 'translate(0 0)',
      fill: color
    }), _react2.default.createElement('path', {
      id: 'Path_196',
      'data-name': 'Path 196',
      d: 'M0,0H32V32H0Z',
      fill: 'none'
    }));
  },
  view_module: function view_module(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    }, _react2.default.createElement('g', {
      id: 'view_module-24px',
      transform: 'translate(32) rotate(90)'
    }, _react2.default.createElement('path', {
      id: 'Path_197',
      'data-name': 'Path 197',
      d: 'M4,14.692h7.353V5H4ZM4,26h7.353V16.308H4Zm8.824,0h7.353V16.308H12.824Zm8.824,0H29V16.308H21.647ZM12.824,14.692h7.353V5H12.824ZM21.647,5v9.692H29V5Z',
      fill: color
    }), _react2.default.createElement('path', {
      id: 'Path_198',
      'data-name': 'Path 198',
      d: 'M0,0H32V32H0Z',
      fill: 'none'
    })));
  },
  assignment: function assignment(size, color) {
    return _react2.default.createElement('svg', {
      id: 'assignment-24px',
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    }, _react2.default.createElement('path', {
      id: 'Path_261',
      'data-name': 'Path 261',
      d: 'M0,0H32V32H0Z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      id: 'Path_262',
      'data-name': 'Path 262',
      d: 'M26.111,3.8H20.073a4.363,4.363,0,0,0-8.147,0H5.889A2.854,2.854,0,0,0,3,6.6V26.2A2.854,2.854,0,0,0,5.889,29H26.111A2.854,2.854,0,0,0,29,26.2V6.6A2.854,2.854,0,0,0,26.111,3.8ZM16,3.8a1.427,1.427,0,0,1,1.444,1.4,1.445,1.445,0,0,1-2.889,0A1.427,1.427,0,0,1,16,3.8Zm2.889,19.6H8.778V20.6H18.889Zm4.333-5.6H8.778V15H23.222Zm0-5.6H8.778V9.4H23.222Z',
      transform: 'translate(0)',
      fill: color
    }));
  },
  download: function download(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      fill: color,
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z'
    }));
  },
  add_task: function add_task(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('rect', {
      fill: 'none',
      height: '24',
      width: '24'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8 c1.57,0,3.04,0.46,4.28,1.25l1.45-1.45C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12s4.48,10,10,10c1.73,0,3.36-0.44,4.78-1.22 l-1.5-1.5C14.28,19.74,13.17,20,12,20z M19,15h-3v2h3v3h2v-3h3v-2h-3v-3h-2V15z'
    }));
  },
  check_circle: function check_circle(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
    }));
  },
  check_circle_outline: function check_circle_outline(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0V0zm0 0h24v24H0V0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
    }));
  },
  crm_logo: function crm_logo(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z'
    }));
  },
  bi_logo: function bi_logo(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
    }));
  },
  admin_logo: function admin_logo(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z'
    }));
  },
  b2b_logo: function b2b_logo(size, color) {
    return _react2.default.createElement('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      height: size,
      viewBox: '0 0 24 24',
      width: size
    }, _react2.default.createElement('path', {
      d: 'M0 0h24v24H0z',
      fill: 'none'
    }), _react2.default.createElement('path', {
      fill: color,
      d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'
    }));
  }
};